import PageBasicTemplate from '../components/PageBasicTemplate';
import { ProductsSection, ServicesSection, ContactBanner } from '../components/redesign/BusinessSections';
export default function Service() {
  return <PageBasicTemplate title="事業紹介" sub_title="AIの構想から、開発・実装・運用まで。事業の変化を、技術で支えます。"><div className="service-page"><ServicesSection standalone /><ProductsSection /><ContactBanner /></div></PageBasicTemplate>;
}
